import { Box, Text } from '@factorialco/deprecated-design-system'

import { CentToFormattedAmount } from 'modules/finance/components/FinancialWorkspace/components/chart/helpers'
import { PARSED_ITEMS } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/chart/helpers'

interface ComparisonsProp {
  index: number
  label: string
  showTotal: boolean
  items: PARSED_ITEMS
  showDivider: boolean
  showLaborCost: boolean
  showAgreementData: boolean
  showEmployeeExpenses: boolean
  toAmount: (value: number) => CentToFormattedAmount
}

const Comparisons = ({
  items,
  index,
  toAmount,
  showTotal,
  showDivider,
  showLaborCost,
  showAgreementData,
  showEmployeeExpenses,
  label,
}: ComparisonsProp) => {
  const {
    COMPARISON_LABOR_COST,
    COMPARISON_AGREEMENT_DATA,
    COMPARISON_TOTAL_EXPENSES,
    COMPARISON_EMPLOYEE_EXPENSES,
  } = items

  return (
    <Box flexDirection="column" gap="s8" alignItems="flexEnd">
      <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="flexStart">
        <Text.Normal size="300" weight="bold" color="grey1000">
          {label}
        </Text.Normal>
      </Box>
      {showAgreementData && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Text.Normal size="200" color="grey1000">
            {COMPARISON_AGREEMENT_DATA?.[index]?.y
              ? toAmount(Number(COMPARISON_AGREEMENT_DATA?.[index]?.y)).amount
              : '-'}
          </Text.Normal>
        </Box>
      )}
      {showDivider && <Box background="grey200" width="full" height="s2" />}
      {showEmployeeExpenses && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Text.Normal size="200" color="grey1000">
            {COMPARISON_EMPLOYEE_EXPENSES?.[index]?.y
              ? toAmount(Number(COMPARISON_EMPLOYEE_EXPENSES?.[index]?.y)).amount
              : '-'}
          </Text.Normal>
        </Box>
      )}
      {showLaborCost && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Text.Normal size="200" color="grey1000">
            {COMPARISON_LABOR_COST?.[index]?.y
              ? toAmount(Number(COMPARISON_LABOR_COST?.[index]?.y)).amount
              : '-'}
          </Text.Normal>
        </Box>
      )}
      {showTotal && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Text.Normal weight="medium" size="200" color="grey1000">
            {COMPARISON_TOTAL_EXPENSES?.[index]?.y
              ? toAmount(Number(COMPARISON_TOTAL_EXPENSES?.[index]?.y)).amount
              : '-'}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export { Comparisons }
